import type { RouteProp } from '@react-navigation/core';
import type { StackNavigationProp } from '@react-navigation/stack';

import {
  BooleanParam,
  CoreRootStackParamList,
  DeeplinkConfigShape,
  NumberParam,
} from '@oui/app-core/src/types/navigation';

export type StressBreathingExerciseType = 'holding' | 'hyperventilation';

export type StressBreathingStackParamList = {
  StressBreathingIndex: { type: StressBreathingExerciseType };
  StressBreathingShow: { type: StressBreathingExerciseType; practiceID: string };
  StressBreathingNew: {
    type: StressBreathingExerciseType;
    round: NumberParam;
    break: BooleanParam;
    practiceID?: string;
  };
};

export const STRESS_BREATHING_DEEPLINK_CONFIG = {
  StressBreathingIndex: 'stress-breathing',
  StressBreathingNew: 'stress-breathing/new',
  StressBreathingShow: 'stress-breathing/:practiceID',
} as const satisfies DeeplinkConfigShape<keyof StressBreathingStackParamList>;

type FullStackParamList = StressBreathingStackParamList & CoreRootStackParamList;

export type StackScreenProps<
  T extends keyof StressBreathingStackParamList,
  Other extends object = {},
> = {
  navigation: StackNavigationProp<FullStackParamList, T>;
  route: RouteProp<FullStackParamList, T>;
} & Other;

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace ReactNavigation {
    // eslint-disable-next-line @typescript-eslint/no-empty-interface
    interface RootParamList extends FullStackParamList {}
  }
}
